import { certificateOfStudies as schemaCertificateOfStudies } from './schemas';
import apiClient from './apiClient';
import CertificateOfStudiesDataStore from '../../datastores/CertificateOfStudiesDataStore';

class CertificateOfStudiesDataStoreGraphQL
  implements CertificateOfStudiesDataStore
{
  client = apiClient();

  async register(
    procedureId: number,
    period: string,
    periodDesc: string,
    program: string,
    weightedAverage: string,
    hasDebts: boolean
  ) {
    try {
      const response = await this.client.mutate({
        mutation:
          schemaCertificateOfStudies.registerCertificateOfStudiesProcedure,
        variables: {
          procedureId,
          period,
          periodDesc,
          program,
          weightedAverage,
          hasDebts
        }
      });
      const { data } = response;
      return data?.registerCertificateOfStudiesProcedure;
    } catch (error) {
      throw new Error('error certificate of studies register');
    }
  }

  async activatePayment(
    procedureId: number,
    requestId: number,
    career: string
  ) {
    try {
      const response = await this.client.mutate({
        mutation:
          schemaCertificateOfStudies.activateCertificateOfStudiesProcedure,
        variables: { procedureId, requestId, career }
      });
      const { data } = response;
      return data.activateCertificateOfStudiesProcedure;
    } catch (error) {
      throw new Error('error certificate of studies payment activation');
    }
  }

  async downloadFile(key: string) {
    try {
      const response = await this.client.mutate({
        mutation: schemaCertificateOfStudies.downloadSimpleFile,
        variables: { key }
      });
      const { data } = response;
      return data.download;
    } catch (error) {
      throw new Error('error certificate of studies payment activation');
    }
  }

  async paymentsStatusVerification(requestId: number) {
    try {
      const response = await this.client.query({
        query: schemaCertificateOfStudies.paymentsStatusVerification,
        variables: { requestId }
      });
      const { data } = response;
      return data?.paymentsVerification;
    } catch (error) {
      throw new Error('error certificate of studies payments verification');
    }
  }
}

export default CertificateOfStudiesDataStoreGraphQL;
